import apiBase from "../../api/axios";

// Servicio para obtener talentos selectores por plantel
export const getTalentosSelectoresPlantelService = async (
  plantelId,
  search = "",
) => {
  const params = { plantel: plantelId };
  if (search) {
    params.search = search;
  }
  const response = await apiBase.get(
    "v1/talentos-plantel/selectores/talentos/",
    { params },
  );
  return response.data;
};

// Servicio para obtener frases disponibles por talento y plantel
export const getFrasesDisponiblesPlantelService = async (
  plantelId,
  talentoId,
  random = false,
) => {
  const params = { plantel: plantelId };

  if (talentoId) {
    params.talento = talentoId;
  }

  if (random) {
    params.only_random = true;
  }

  const response = await apiBase.get(
    "v1/talentos-plantel/frases-disponibles/",
    { params },
  );
  return response.data;
};

// Servicio para obtener configuraciones VS por plantel
export const getConfiguracionesPlantelService = async (plantelId) => {
  const response = await apiBase.get("v1/talentos-plantel/configuracion-vs/", {
    params: { plantel: plantelId },
  });
  return response.data;
};

// Servicio para crear configuración VS en plantel
export const createConfiguracionPlantelService = async (
  plantelId,
  frase1Id,
  frase2Id,
) => {
  const payload = {
    plantel: plantelId,
    frase_1: frase1Id,
    frase_2: frase2Id,
  };
  const response = await apiBase.post(
    "v1/talentos-plantel/configuracion-vs/",
    payload,
  );
  return response.data;
};

// Servicio para actualizar configuración VS en plantel
export const updateConfiguracionPlantelService = async (
  id,
  frase1Id,
  frase2Id,
) => {
  const payload = {
    frase_1: frase1Id,
    frase_2: frase2Id,
  };
  const response = await apiBase.put(
    `v1/talentos-plantel/configuracion-vs/${id}/`,
    payload,
  );
  return response.data;
};

// Servicio para eliminar configuración VS en plantel
export const deleteConfiguracionPlantelService = async (id) => {
  const response = await apiBase.delete(
    `v1/talentos-plantel/configuracion-vs/${id}/`,
  );
  return response.data;
};

export const getPreguntasSelectoresPlantelService = async (
  plantelId,
  search = "",
) => {
  let url = `v1/talentos-plantel/selectores/preguntas-confirmacion/?plantel=${plantelId}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const response = await apiBase.get(url);
  return response.data;
};
